const tireTypeOptions = [
  { label: "夏タイヤ", value: "s" },
  { label: "冬タイヤ", value: "w" },
  { label: "オールシーズン", value: "a" },
];

const tireCategoryText = (type: string) =>
  tireTypeOptions.find((item) => item.value === type)?.label || "";

export { tireCategoryText, tireTypeOptions };
